export default __webpack_public_path__ + "static/media/whiteLogo.13270005.svg";